import $ from 'jquery';
import Notices from './models/notices';
import NoticesView from './views/view';
import NoticesModalView from './views/modal';
import NoticesStickyView from './views/sticky';
import env from './environments/index';

let el;
let url;
let userData;
let cors;
let notices;
let notice;
let view;
let afterRender;

const corsOptions = {
  crossDomain: true,
  xhrFields: {
    withCredentials: true,
  },
};

const getCookie = (cname) => {
  const name = `${cname}=`;
  // eslint-disable-next-line no-undef
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.substring(name.length, c.length) !== 'null') {
        return c.substring(name.length, c.length);
      }
      return null;
    }
  }
  return '';
};

// eslint-disable-next-line arrow-parens
const getNoticesStickyView = (noticeData) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  new NoticesStickyView({
    el,
    noticeData,
    openCallback: () => {
      // eslint-disable-next-line no-use-before-define
      render();
    },
  });
const getSyncOptions = () => (cors === true ? corsOptions : {});

// eslint-disable-next-line arrow-parens
const notificationSelector = (id) => `.notifications[data-noticeid="${id}"]`;

const loadData = (callback) => {
  const options = Object.assign({}, getSyncOptions(), {
    success: (response) => {
      if (response.at(0) && response.at(0).attributes.response !== 'error') {
        callback();
      }
    },
    error: (error, response) => {
      throw new Error('mdnotice.loadData error:', response);
    },
  });
  notices.fetch(options);
};

const afterRenderCallback = () => {
  if (typeof afterRender === 'function') {
    afterRender();
  }
};

let closeCallbackPopup;
let closeCallback;

const render = () => {
  notice = notices.at(0);

  const id = notice && notice.get('id');
  if (!id) {
    afterRenderCallback();
    return;
  }

  if ($(notificationSelector(id)).length > 0) {
    afterRenderCallback();
    return;
  }
  const popup = parseInt(notice.get('popup'), 10) === 1;
  const hasCookie = getCookie(`${env.cookie}${id}`);
  // eslint-disable-next-line no-nested-ternary
  const View = popup ? (hasCookie ? NoticesStickyView : NoticesModalView) : NoticesView;
  view = new View({
    el,
    noticeData: notice.getNoticeData(userData),
    closeCallback: (data) => {
      const closeFn = popup ? closeCallbackPopup : closeCallback;
      return closeFn(data.noticeData, data.delete, data.callback);
    },
    // eslint-disable-next-line no-nested-ternary
    openCallback: popup ? (hasCookie ? render : null) : null,
  });
  view.render();
  afterRenderCallback();
};

const deleteNoticeAction = (callback) => {
  const id = notice.get('id');
  const data = JSON.stringify({ id });

  const options = Object.assign({}, getSyncOptions(), {
    data,
    url: `${url}/${id}`,
    contentType: 'application/json',
    success: () => {
      $(notificationSelector(id)).remove();
      if (callback) {
        callback();
      } else {
        loadData(() => {
          render();
        });
      }
    },
    error: (error, response) => {
      throw new Error('mdnotice.deleteNoticeAction error', error, response);
    },
  });
  notice.destroy(options);
};

closeCallbackPopup = (noticeData, deleteNotice, callback) => {
  $('#notice-sticky').remove();
  view = getNoticesStickyView(noticeData);
  if (deleteNotice) {
    return deleteNoticeAction(callback);
  }
  view.render();
  return afterRenderCallback();
};

closeCallback = (noticeData, deleteNotice) => {
  if (deleteNotice) {
    return deleteNoticeAction();
  }
  return $(notificationSelector(noticeData.id)).remove();
};

const showNotices = () => {
  notices = new Notices([], { url });
  notices.url = url;
  loadData(() => {
    render();
  });
};

export default {
  init: (options) => {
    // eslint-disable-next-line object-curly-newline
    ({ el, url, userData, afterRender, cors } = options);
    showNotices();
  },
  getNotice: () => notice,
  getView: () => view,
  deleteNotice: () => {
    if (notice) {
      deleteNoticeAction();
    }
  },
  close: () => {
    if (view) {
      view.close();
    }
  },
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/